import { Range } from "immutable";

import { getTokenAPI, refreshTokenAPI } from "./api";
import { getAPI as getAdminAPI } from "../admin/api";
import { ValidationError } from "../../common/lib/validation";
import { handleError, apiRequest } from "../lib/utils/request";
import moment from "moment";
import cookie from "react-cookie";

export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";
export const SIGN_IN_FINALLY = "SIGN_IN_FINALLY";

export const SIGN_OUT = "SIGN_OUT";

export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_ERROR = "REFRESH_TOKEN_ERROR";
export const REFRESH_TOKEN_FINALLY = "REFRESH_TOKEN_FINALLY";

export const GET_CURRENT_ADMIN = "GET_CURRENT_ADMIN";
export const GET_CURRENT_ADMIN_SUCCESS = "GET_CURRENT_ADMIN_SUCCESS";
export const GET_CURRENT_ADMIN_ERROR = "GET_CURRENT_ADMIN_ERROR";
export const GET_CURRENT_ADMIN_FINALLY = "GET_CURRENT_ADMIN_FINALLY";

export const REMOVE_TOKEN = "REMOVE_TOKEN";
export const SET_REFRESH_TOKEN_INTERVAL = "SET_REFRESH_TOKEN_INTERVAL";

export const AUTH_CLEAR_ERROR = "AUTH_CLEAR_ERROR";

const validateEmailAndPassword = (validate, msg, fields) =>
  validate(fields)
    .prop("username", "usernamePassword")
    .required(msg["app.validation.required"])
    .email(msg["app.validation.email"])
    .prop("password", "usernamePassword")
    .required(msg["app.validation.required"])
    .getErrors();

export const signIn = data => async (dispatch, getState, utils) => {
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      SIGN_IN,
      validateEmailAndPassword,
      getTokenAPI,
      data,
      null,
      body => {
        return new ValidationError("usernamePassword", "");
      }
    );

    if (rs && rs.status === 200) {
      const uid = JSON.parse(atob(rs.body.token.split(".")[1])).uid;
      dispatch(getCurrentAdmin({ uid: uid }));
    }

    return rs;
  } catch (error) {
    handleError(dispatch, getState, SIGN_IN, error);
  }
};

export const getCurrentAdmin = data => async (dispatch, getState, utils) => {
  const action = GET_CURRENT_ADMIN;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAdminAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const signOut = () => ({
  type: SIGN_OUT
});

export const refreshToken = () => async (dispatch, getState, utils) => {
  const token = getState().auth.token;
  if (!token) {
    return "notoken";
  }

  const expiryDate = moment(token.expire);
  const timeDiff = expiryDate.diff(moment(), "seconds");

  // check if token is expired already
  if (timeDiff <= 0) {
    dispatch({ type: REMOVE_TOKEN });
    return "expired";
  }

  if (timeDiff <= 86400 / 2) {
    try {
      return await apiRequest(
        dispatch,
        getState,
        utils,
        REFRESH_TOKEN,
        null,
        refreshTokenAPI,
        null,
        { authorized: true },
        body => {
          dispatch({ type: REMOVE_TOKEN });
          return new ValidationError("", "");
        }
      );
    } catch (error) {
      handleError(dispatch, getState, REFRESH_TOKEN, error);
    }
  }

  return "nothing";
};

export const setRefreshTokenInterval = interval => ({
  type: SET_REFRESH_TOKEN_INTERVAL,
  payload: { interval }
});

export const clearAuthError = field => ({
  type: AUTH_CLEAR_ERROR,
  payload: { field }
});



// WEBPACK FOOTER //
// ./src/common/auth/actions.js